import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { crmDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'UsersRound'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.CRM,
  displayName: 'CRM',
  label: 'CRM',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE, MODULES.ACCOUNTING],
  category: 'crm',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'CRM',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'การขาย',
        items: [
          { label: 'แดชบอร์ด', path: '/crm/dashboard', icon: 'LayoutDashboard', exact: true },
          { label: 'ลีด', path: '/crm/leads', icon: 'UserPlus' },
          { label: 'ดีล', path: '/crm/deals', icon: 'Handshake' },
          { label: 'ผู้ติดต่อ', path: '/crm/contacts', icon: 'Contact' },
          { label: 'องค์กร', path: '/crm/organizations', icon: 'Building2' },
          { label: 'ปฏิทิน', path: '/crm/calendar', icon: 'CalendarDays' },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'แหล่งที่มา', path: '/crm/sources', icon: 'Globe' },
          { label: 'เหตุผลปิดดีล', path: '/crm/lost-reasons', icon: 'XCircle' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "lead", label: "ลีด", assignedField: "assignedTo" },
    { key: "deal", label: "ดีล", assignedField: "assignedTo" },
    { key: "contacts", label: "ผู้ติดต่อ" },
    { key: "organizations", label: "องค์กร" },
    { key: "activities", label: "กิจกรรม", assignedField: "assignedTo" },
  ],
  availableHooks: [
    { event: "crm.lead.converted", label: "แปลง Lead เป็น Deal" },
  ],
  customForms: [
    { key: "crm.won-deal", label: "ปิดการขายสำเร็จ" },
    { key: "crm.lost-deal", label: "ปิดการขายไม่สำเร็จ (เลือกเหตุผล)" },
    { key: "crm.convert-lead", label: "แปลง Lead เป็น Deal" },
  ],
  fixtures: [
    { file: 'lead-sources.json', doctype: 'crm_lead_source' },
    { file: 'lost-reasons.json', doctype: 'crm_lost_reason' },
  ],

  moduleMigrations: migrations,

  // Doctype Admin Epic (#347) issue C1 (#359). See `./doctypes.ts` — the
  // platform boot loop in `apps/tenant-worker/src/middleware/auto-migrate.ts`
  // reads this field from every enabled module's manifest and upserts the
  // platform-default rows into `core_doctype_registry`. The glue itself
  // was introduced by B1 (#356) and is strictly generic — this field is
  // the only CRM-side wiring required.
  registeredDoctypes: crmDoctypes,
})
